import { Box, Tooltip } from '@mui/material'
import { swalActive, swalCustom } from 'component/Alert/Swal'
import ButtonCustom from 'component/Button/ButtonCustom'
import PromotionExportButton from 'features/manage-crm/promotion/promotion-export'
import HeaderCard from 'component/CardCustom/HeaderCard'
import InputTextField from 'component/Input/InputTextField'
import Loading from 'component/Loading'
import AutocompleteSelect from 'component/Select/AutocompleteSelect'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon, { DropdownItem } from 'component/Table/TableRowCommon'
import { ListFilterDoctors } from 'features/counter/appointment/head-appointment'
import _ from 'lodash'
import React, { useEffect, useState } from 'react'
import { Card, Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { canEditPromotion } from './promotion-actions.utils'
import { useHistory } from 'react-router-dom'
import { toBuddhistYear } from 'utils/app.utils'
import { isCreate, isDelete, isView, isUpdate, isCopy } from 'utils/verification.utils'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors } from 'constants/theme'
import ClinicApi, { BranchInterface } from 'api/master/clinic.api'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { routeName } from 'routes/routes-name'
import PromotionsApi from 'api/promotion/promotion.api'
import { showModal } from 'app/slice/modal.slice'
import PopViewPromotion from './pop-view-promotion'
import { notiSuccess, notiError } from 'component/notifications/notifications'
import MainButton from 'new-components/buttons/main-button'

const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isView: isView(),
    isCopy: isCopy(),
}

const Promotions = () => {
    const { t } = useTranslation()
    const history = useHistory()
    const dispatch = useDispatch()
    const [load, setLoad] = useState<boolean>(false)

    const [dataPromotion, setDataPromotion] = useState<any>([])

    const styleSelector = { textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }
    const statusOption = [
        { status: 'WAITING' }, { status: 'USING' }, { status: "EXPIRED" }, { status: 'CLOSED' },
    ]
    const [statusSelect, setStatusSelect] = useState<string>('')
    const [branches, setBranches] = useState<BranchInterface[]>([])

    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createdAt')
    const [sortType, setSortType] = useState('DESC')
    const [search, setSearch] = useState('')

    const [popViewPromotion, setPopViewPromotion] = useState<boolean>(false)
    const [dataPopViewPromotion, setDataPopViewPromotion] = useState<any>({})

    const loadFilterOption = async () => {
        await ClinicApi.findAllActiveBranches().then(({ data }) => data && setBranches(data))
    }

    const loadPromotion = async () => {
        setLoad(true)
        const condition = {
            page: page,
            pageLimit: pageLimit,
            SEARCH: search,
            sortBy: sortBy,
            sortType: sortType,
            STATUS: statusSelect,
            EXPORT: '0',
        }

        await PromotionsApi.findAll(condition).then((res) => {
            setRowCount(res?.headers['x-total'] || 0)
            setDataPromotion(res?.data)
        }).finally(() => {
            setLoad(false)
        })
    }

    const fetchExportRows = async (): Promise<any[]> => {
        const condition = {
            SEARCH: search,
            sortBy: sortBy,
            sortType: sortType,
            STATUS: statusSelect,
            EXPORT: '1',
        }
        const res: any = await PromotionsApi.findAll(condition)
        return res?.data || []
    }

    useEffect(() => {
        loadFilterOption()
    }, [])

    useEffect(() => {
        loadPromotion()
    }, [page, pageLimit])

    const onCreate = () => {
        history.push(`${routeName.promotion}/create`)
    }

    const onEdit = (obj: any) => {
        history.push(`${routeName.promotion}/update`, { ...obj })
    }

    const onView = (obj: any) => {
        setPopViewPromotion(true)
        dispatch(showModal())
        setDataPopViewPromotion(obj)
    }

    const onClosePopViewPromotion = () => {
        setPopViewPromotion(false)
    }

    const onCopy = (obj: any) => {
        history.push(`${routeName.promotion}/create`, { ...obj, copy: true })
    }

    const onDelete = async (data: any) => {
        const { promotionNameEn, promotionName, promotionId } = data

        swalCustom(
            `<p class="mb-0 mx-auto" style="max-width: 325px">${t('PROMOTION.MESSAGE.DEL_TITLE')}</p>`,
            `<p class="mb-0 mx-auto" style="max-width: 325px">${t('PROMOTION.MESSAGE.DEL_SUB', { promotionName: promotionName, promotionNameEn: promotionNameEn })}</p>`,
            (res: any) => {
                if (res && promotionId) {
                    setLoad(true)
                    PromotionsApi.deletePromotion(promotionId).then((res) => {
                        notiSuccess(t('PROMOTION.MESSAGE.DEL_SUCCESS'))
                        loadPromotion()
                    }).catch((error) => {
                        const errMsg = error?.response?.data?.message
                        if (errMsg === 'PROMOTION_IS_USED') {
                            notiError(t('PROMOTION.MESSAGE.PROMOTION_IS_USED'))
                        } else {
                            notiError(t('PROMOTION.MESSAGE.ERROR_'))
                        }
                    }).finally(() => {
                        setLoad(false)
                    })
                }
            }, 'warning', { showCloseButton: false, containerClass: 'promotion-del', confirmButton: { confirmClassName: 'promotion-del-con' } }
        )

    }

    const onEarlyClose = async (data: any) => {
        const { promotionNameEn, promotionName, promotionId } = data

        swalCustom(
            `<p class="mb-0 mx-auto" style="max-width: 325px">${t('PROMOTION.MESSAGE.CLOSE_TITLE')}</p>`,
            `<p class="mb-0 mx-auto" style="max-width: 325px">${t('PROMOTION.MESSAGE.CLOSE_SUB', { promotionName: promotionName || '', promotionNameEn: promotionNameEn || '' })}</p>`,
            (res: any) => {
                if (res && promotionId) {
                    setLoad(true)
                    PromotionsApi.earlyClosePromotion(promotionId).then(() => {
                        notiSuccess(t('PROMOTION.MESSAGE.CLOSE_SUCCESS'))
                        loadPromotion()
                    }).catch((error) => {
                        const errMsg = error?.response?.data?.message
                        if (errMsg === 'PROMOTION_EXPIRED') {
                            notiError(t('PROMOTION.MESSAGE.PROMOTION_EXPIRED'))
                        } else {
                            notiError(t('PROMOTION.MESSAGE.ERROR_'))
                        }
                    }).finally(() => {
                        setLoad(false)
                    })
                }
            }, 'warning', { showCloseButton: false }
        )
    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangePage = (val: number) => setPage(val)

    const handleChangeRowsPerPage = (limit: number) => setPageLimit(limit)

    const getUsageLabel = (usage: string) => {
        switch (usage) {
            case 'ALL': return t('PROMOTION.FORM.USAGE_ALL')
            case 'OPERATIVE': return t('PROMOTION.FORM.USAGE_LIST_DF_CF')
            case 'OPERATIVEDF': return t('PROMOTION.FORM.USAGE_LIST_DF')
            case 'OPERATIVECF': return t('PROMOTION.FORM.USAGE_LIST_CF')
            case 'PRODUCT': return t('PROMOTION.FORM.USAGE_LIST_PD')
            default: return '-'
        }
    }

    const getConditionSummary = (row: any) => {
        const parts: string[] = []
        const scope = row?.discountScope || (row?.promotionUsage === 'ALL' ? 'TOTAL' : 'ITEM')
        parts.push(scope === 'TOTAL' ? t('PROMOTION.FORM.USAGE_ALL') : t('PROMOTION.FORM.USAGE_LIST'))
        if (scope === 'TOTAL' && row?.promotionUsage !== 'ALL') {
            const usage = getUsageLabel(row?.promotionUsage)
            if (usage && usage !== '-') parts.push(usage)
        } else if (scope === 'ITEM') {
            const usage = getUsageLabel(row?.promotionUsage)
            if (usage && usage !== '-') parts.push(usage)
        }
        const price = row?.promotionPrice != null && row?.promotionPrice !== '' ? `${Number(row.promotionPrice)} ${row?.promotionPriceUnit === 'PERCENT' ? '%' : t('CURRENCY_CHANGE.TH')}` : null
        if (price) parts.push(price)
        if (row?.promotionUsage === 'OPERATIVE' && (row?.promotionPriceDF != null || row?.promotionPriceCF != null)) {
            const unit = row?.promotionPriceDFUnit === 'BAHT' ? t('CURRENCY_CHANGE.TH') : '%'
            parts.push(`DF ${row?.promotionPriceDF ?? 0}${unit} / CF ${row?.promotionPriceCF ?? 0}${unit}`)
        }
        return parts.length ? parts.join(' · ') : '-'
    }

    const headCells = [
        { id: 'no', disablePadding: false, label: '#', width: '50px', align: 'center', },
        { id: 'promotionTypeName', disablePadding: false, label: t('PROMOTION.TABLE.PROMOTION_TYPENAME'), align: 'left', class: 'text-nowrap ' },
        { id: 'promotionCode', disablePadding: false, label: t('PROMOTION.TABLE.PROMOTION_CODE'), align: 'center', class: 'text-nowrap' },
        { id: 'promotionName', disablePadding: false, label: t('PROMOTION.TABLE.PROMOTION_NAME_TH'), align: 'left', class: 'text-nowrap col-pro-name' },
        { id: 'promotionNameEn', disablePadding: false, label: t('PROMOTION.TABLE.PROMOTION_NAMEEN'), align: 'left', class: 'text-nowrap' },
        { id: 'condition', disablePadding: false, label: t('VOUCHER.TABLE.CONDITION') || 'เงื่อนไข', align: 'left', class: 'text-nowrap col-condition', minWidth: '340px' },
        { id: 'promotionFormat', disablePadding: false, label: t('PROMOTION.TABLE.TYPE'), align: 'center', class: 'text-nowrap' },
        { id: 'branch', disablePadding: false, label: t('PROMOTION.TABLE.USAGE_BRANCH'), align: 'left', class: 'text-nowrap' },
        { id: 'count', disablePadding: false, label: t('PROMOTION.TABLE.COUNT'), align: 'center', class: 'text-nowrap' },
        { id: 'dateStart', disablePadding: false, label: t('PROMOTION.TABLE.USAGE_DATE'), align: 'center', class: 'text-nowrap' },
        { id: 'status', disablePadding: false, label: t('APPLICATION.TABLE.CELL.STATUS'), align: 'center', width: '150px' },
        { id: 'updatedBy', disablePadding: false, label: t('APPLICATION.TABLE.CELL.UPDATED_BY'), align: 'center', width: '180px' },
        { id: 'action', disablePadding: false, label: 'Action', width: '80px' }
    ]

    const renderData = (objData: any, index: number) => {
        index = page * pageLimit - pageLimit + index + 1

        const { promotionId, promotionCode, promotionName, promotionNameEn, promotionType,
            updatedBy, updatedAt, createdAt, status, branch, count, dateStart, dateEnd, amountPromotion, everRedeemed, usedCount, promotionBranchs, type, promotionDate } = objData

        const everRedeemedCount = Number(everRedeemed) || 0
        const isWaiting = status === 'WAITING'
        const isUsing = status === 'USING'
        const canEdit = canEditPromotion({ status, usedCount })
        const canDelete = (isWaiting || isUsing) && everRedeemedCount === 0
        const canEarlyClose = isWaiting || isUsing

        const closeAction = canEarlyClose
            ? [{
                option: 'COMPONANT',
                label: (
                    <DropdownItem
                        key={`close-${promotionId}`}
                        onClick={() => onEarlyClose(objData)}
                        disabled={permissions.isUpdate.disabled}
                    >
                        <FontAwesomeIcon icon={faCircle} color={colors.statusInactive} style={{ fontSize: '8px' }} />
                        <span className="ml-2 align-text-bottom">{t('PROMOTION.BUTTON.CLOSE_PROMOTION')}</span>
                    </DropdownItem>
                ),
            }]
            : []

        const valueAction = [
            { option: 'VIEW', label: t(`BUTTON.VIEW`), disabled: permissions.isView.disabled },
            ...(canEdit ? [{ option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled }] : []),
            { option: 'COPY', label: t(`BUTTON.COPY`), disabled: permissions.isCopy.disabled },
            ...(canDelete ? [{ option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }] : []),
            ...closeAction,
        ]

        const objRenderData = {
            key: promotionId,
            id: promotionId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: index },
                { option: 'TEXT', align: 'left', label: promotionType?.promotionTypeName || '' },
                { option: 'TEXT', align: 'left', label: promotionCode || '' },
                { option: 'TEXT', align: 'left', label: promotionName || '' },
                { option: 'TEXT', align: 'left', label: promotionNameEn || '' },
                { option: 'TEXT', align: 'left', label: getConditionSummary(objData), class: 'col-condition' },
                { option: 'TEXT', align: 'center', label: type ? t(`PROMOTION.TYPE.${type}`) : '' },
                {
                    option: 'COMPONENT',
                    component: <BoxBranchFilter filterBranch={promotionBranchs?.length ? promotionBranchs : []} />
                },
                { option: 'TEXT', align: 'center', label: amountPromotion || '' },
                { option: 'TEXT', align: 'center', label: promotionDate || '', class: 'text-nowrap' },
                {
                    option: 'COMPONENT',
                    class: 'row-status',
                    component: (
                        <Box className={'text-nowrap'}>
                            <FontAwesomeIcon icon={faCircle} color={status === 'USING' ? colors.statusActive : (status === 'EXPIRED' || status === 'CLOSED') ? colors.statusInactive : '#EDBA07'} />
                            <span className="ml-2">{t(`PROMOTION.STATUS.${status}`)}</span>
                        </Box>
                    )
                },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy || '-', updatedAt: updatedAt ?? '10/12/2564 08.59' } },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    values: valueAction
                },
            ]
        }

        return (
            <TableRowCommon
                {...objRenderData}
                onedit={() => onEdit(objData)}
                ondelete={() => onDelete(objData)}
                onView={() => onView(objData)}
                oncopy={() => onCopy(objData)}
            />
        )
    }

    return (
        <>
            <Box>
                <Loading show={load} />
                <Card className="border-0 h-100">
                    <HeaderCard text={t('PROMOTION.TITLE')} />
                    <Card.Body className="overflow-auto">
                        <Card.Title className={'mb-0 pl-xl-3'}>
                            <Box className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                                <Box className="d-flex align-items-center gap-2" sx={{ width: { md: 'calc(100% - 350px)', xs: '100%' } }}>
                                    <Box sx={{ width: { md: '36%', xs: '100%' } }}>
                                        <InputTextField
                                            // label={t('PROMOTION_TYPE.SEARCH')}
                                            placeholder={t('PROMOTION.SEARCH_PLACEHOLDER')}
                                            value={search}
                                            onchange={(e) => {
                                                setSearch(e.target.value)
                                            }}
                                        />
                                    </Box>
                                    <Box sx={{ width: { md: '36%', xs: '100%' } }}>
                                        <AutocompleteSelect
                                            labelId="status"
                                            options={["ALL", ...statusOption]}
                                            getOptionLabel={(option) => `${t('APPROVELLIST.FILTER.STATUS')}: ${option.status ? t(`PROMOTION.STATUS.${option.status}`) : t('ALL')} `}
                                            renderOption={(props, option) => {
                                                return (
                                                    <ListFilterDoctors {...props} component="li" sx={styleSelector}>
                                                        {option === "ALL" ? t('ALL') : t(`PROMOTION.STATUS.${option.status}`)}
                                                    </ListFilterDoctors>
                                                )
                                            }}
                                            onchange={(e, value) => {
                                                setStatusSelect(value?.status || '')
                                            }}
                                            noOptionsText={t('NOT_FOUND')}
                                            filterOptions={(option) => t(`STATUS.${option?.status || ''}`)}
                                            value={_.find(statusOption, { status: statusSelect }) || ''}
                                            height={43}
                                            disableClearable={!statusSelect && statusSelect !== 'ALL'}
                                        />
                                    </Box>
                                    <Box sx={{ width: 'fit-content' }}>
                                        <MainButton
                                            style={{ width: '100px' }}
                                            onClick={() => {
                                                setPage(1)
                                                loadPromotion()
                                            }}
                                            title={t('INPUT.SEARCH')}
                                            type={'primary'}
                                            variant={'contained'}
                                        />
                                    </Box>
                                </Box>
                                <Box className="d-flex align-items-center gap-2" sx={{ width: 'fit-content' }}>
                                    <Box>
                                        <PromotionExportButton
                                            fetchRows={fetchExportRows}
                                            search={search}
                                            statusSelect={statusSelect}
                                            getConditionSummary={getConditionSummary}
                                            fileName={t('PROMOTION.TITLE')}
                                            title={t('PROMOTION.TITLE')}
                                        />
                                    </Box>
                                    <Box>
                                        <ButtonCustom
                                            mode="add"
                                            disabled={permissions.isCreate.disabled}
                                            onClick={() => onCreate()}
                                            textButton={t('PROMOTION.BUTTON.CREATE_PROMOTION')}
                                            className="w-auto ml-auto d-flex mt-auto"
                                        />
                                    </Box>
                                </Box>
                            </Box>
                        </Card.Title>

                        <Box className={'mt-3 pl-xl-3 pr-xl-2'} sx={{ '.col-pro-name': { minWidth: '250px' }, '.col-condition': { minWidth: '340px' } }}>
                            <TableCustom
                                page={page}
                                pageLimit={pageLimit}
                                sortType={sortType}
                                sortBy={sortBy}
                                onSort={onRequestSort}
                                setPageLimit={handleChangeRowsPerPage}
                                setPage={handleChangePage}
                                rowCount={rowCount}
                                headCells={headCells}
                                rowsData={dataPromotion?.length ? dataPromotion?.map((item: any, index: number) => {
                                    return renderData(item, index)
                                }) : []}
                            />
                        </Box>
                    </Card.Body>
                </Card>
            </Box>

            {popViewPromotion &&
                <PopViewPromotion
                    objData={dataPopViewPromotion}
                    onClose={onClosePopViewPromotion}
                />
            }

        </>
    )
}

export default Promotions

type BoxBranchFilterProps = {
    filterBranch: BranchInterface[]
}

const BoxBranchFilter = (props: BoxBranchFilterProps) => {
    const { filterBranch } = props

    return (
        <Box sx={{
            '.dropdown-toggle': {
                display: 'flex',
                alignItems: 'center',
                backgroundColor: 'transparent !important',
                color: 'black !important',
                border: 'none',
                boxShadow: 'none !important',
                ":after": {
                    display: filterBranch?.length > 1 ? 'block' : 'none'
                },

            },
            '.dropdown-menu': {
                position: 'fixed !important',
                marginBottom: 4,
                background: colors.white,
                border: `1px solid ${colors.lightGray}`,
            }
        }}>
            <Dropdown>
                <Dropdown.Toggle>
                    <Box whiteSpace={'nowrap'} marginRight={'4px'}>
                        {filterBranch[0]?.branchName || ''}
                    </Box>
                </Dropdown.Toggle>
                {filterBranch?.length > 1 &&
                    <Dropdown.Menu>
                        {filterBranch.map((item, index) => {
                            return (
                                <Dropdown.Item key={index}>
                                    {item?.branchName}
                                </Dropdown.Item>
                            )
                        })}
                    </Dropdown.Menu>
                }
            </Dropdown>
        </Box>
    )
}